/* Collection page: format chips (filter the grid in place) + sort auto-submit.
   Everything works without it: all products show, the sort form submits with its button. */
(function () {
  if (window.__kxCollection) return; window.__kxCollection = true;
  document.querySelectorAll('[data-collection]').forEach(function (root) {
    var chipsWrap = root.querySelector('[data-format-chips]');
    var grid = root.querySelector('[data-collection-grid]');
    var count = root.querySelector('[data-result-count]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.kx-card[data-format]')) : [];
    function label(n) { return n + ' ' + (n === 1 ? count.dataset.singular : count.dataset.plural); }
    function apply(format, fromUser) {
      var shown = 0;
      cards.forEach(function (c) { var on = !format || c.dataset.format === format; c.hidden = !on; if (on) shown++; });
      chipsWrap.querySelectorAll('[data-format-chip]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.formatChip === format ? 'true' : 'false'); });
      if (count) count.textContent = label(shown);
      if (fromUser && window.history.replaceState) {
        var u = new URL(window.location.href);
        if (format) u.searchParams.set('format', format); else u.searchParams.delete('format');
        window.history.replaceState(null, '', u.toString());
      }
    }
    if (chipsWrap && cards.length) {
      chipsWrap.hidden = false;
      chipsWrap.addEventListener('click', function (e) { var b = e.target.closest('[data-format-chip]'); if (b) apply(b.dataset.formatChip, true); });
      var start = new URL(window.location.href).searchParams.get('format');
      if (start && chipsWrap.querySelector('[data-format-chip="' + start + '"]')) apply(start, false);
    }
    var sort = root.querySelector('[data-sort-form] select');
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });
  });
})();
